const STORAGE_KEY = 'yurme.chat.reactions.v1';

function readAll() {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota or privacy mode — non-fatal */
  }
}

export function getReactionsFor(messageId) {
  if (messageId == null) return [];
  const all = readAll();
  const v = all[String(messageId)];
  return Array.isArray(v) ? v : [];
}

export function setReactionsFor(messageId, reactions) {
  if (messageId == null) return;
  const all = readAll();
  if (!reactions || reactions.length === 0) {
    delete all[String(messageId)];
  } else {
    all[String(messageId)] = reactions;
  }
  writeAll(all);
}
